function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgButtonBeam = function SvgButtonBeam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    preserveAspectRatio: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M39.11 22.48h-3.49l-.21-18.35h-4.52l-.08 3.69a12.3 12.3 0 0 1-3.16 2.92 13.51 13.51 0 0 1-17.19-2.53l-.12-4.28h-5v18.55H1.05l.42 5.93 3.83-.09v8.77l5.92-.37-.22-8.53 19.34-.45-.2 8.2 5.66.57-.1-8.9 3.42-.08Zm-19.67 0H16.7l-.21-7.26a16 16 0 0 0 3 .49Zm2.17-6.77a15.7 15.7 0 0 0 3.88-.7v7.47h-3.68Zm-11-3.46a14.8 14.8 0 0 0 3.74 2.25v8h-3.51Zm17.23 10.23-.24-8.29.32-.14a14.6 14.6 0 0 0 2.78-1.84l-.24 10.27Z",
    "data-name": "Layer 1",
    style: {
      fill: "#ffce41"
    }
  }));
};
export default SvgButtonBeam;